import {
  GridContainer,
  GridItem,
  InputFormField,
  AppPageContentWrapper,
  useReactHookForm,
  DividerSpg,
  AlertSpg,
  AsyncCallArgs,
  useAsyncCall,
  CircularLoader,
  MediumButton,
  MediumGreyButton,
} from "@duosoftbg/nacid-components";

import { Grid, Typography } from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { SecondaryRecognitionSearchFilter } from "../../../types/secondaryRecognition";
import { secondaryRecognitionSearchFilterInitialValues } from "../../../init/initRequests";
import { seRecognitionSearchValidationSchema } from "../../../yup/secondaryRecognitionSchemas";
import { FormProvider, useFormContext } from "react-hook-form";
import CardContent from "@mui/material/CardContent";
import Box from "@mui/material/Box";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { existsSecondaryByAccessCode } from "../../../axios/api/services";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose, faSearch } from "@fortawesome/free-solid-svg-icons";

const Title = styled.span`
  position: absolute;
  margin-left: 12px;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
`;
const SearchSeRecognitionSection = () => {
  const { t } = useTranslation();
  const { asyncCall } = useAsyncCall();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);

  const { methods } = useReactHookForm<SecondaryRecognitionSearchFilter>({
    defaultValues: secondaryRecognitionSearchFilterInitialValues,
    validationSchema: seRecognitionSearchValidationSchema,
  });
  const onSubmit = async (values) => {
    setLoading(true);
    let accessCode = values.accessCode;

    if (accessCode) {
      const asyncCallArgs: AsyncCallArgs = {
        promise: existsSecondaryByAccessCode(accessCode),
        processResponseErrors: false,
        onSuccess: (response) => {
          if (response) {
            setLoading(false);
            setNotFound(false);
            navigate(`secondary-recognition/checkup?accessCode=${values.accessCode}`);
          } else {
            setLoading(false);
            setNotFound(true);
          }
        },
        onError: () => {
          setLoading(false);
          setNotFound(true);
        },
      };
      asyncCall(asyncCallArgs);
    } else {
      setLoading(false);
      setNotFound(false);
    }
  };
  return (
    <AppPageContentWrapper>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit, (errors) => {})}>
          <CardContent>
            <Typography style={{ position: "relative" }} gutterBottom variant="h5" component="div">
              <Title> {t("m.seRecognitionSearchTitle")}</Title>
            </Typography>
            <DividerSpg my={3} />
            <Box>
              <GridItem sm={12} md={12}>
                <Typography variant="body2" color="text.secondary" align={"justify"}>
                  <span dangerouslySetInnerHTML={{ __html: t("m.seRecognitionSearchDescription") }} />
                </Typography>
              </GridItem>
              <GridContainer mt={5}>
                <Grid container justifyContent="center">
                  <GridItem sm={6} md={6}>
                    <InputFormField fieldName="accessCode" labelCode="l.accessCode" required />
                  </GridItem>
                  <Buttons setNotFound={setNotFound} setLoading={setLoading} />
                </Grid>
              </GridContainer>
              <GridContainer mt={5}>
                <GridItem sm={12} md={12}>
                  {loading && <CircularLoader />}
                  {!loading && notFound && (
                    <AlertSpg severity={"error"} mt={3}>
                      {t("m.seRecognitionAccessCodeNotFound")}
                    </AlertSpg>
                  )}
                </GridItem>
              </GridContainer>
            </Box>
          </CardContent>
        </form>
      </FormProvider>
    </AppPageContentWrapper>
  );
};

const Buttons = ({ setLoading, setNotFound }) => {
  const { t } = useTranslation();
  const { setValue } = useFormContext();

  const onClear = () => {
    setValue("accessCode", secondaryRecognitionSearchFilterInitialValues.accessCode);
    setLoading(false);
    setNotFound(false);
  };

  return (
    <>
      <GridContainer spacing={1}>
        <GridItem sm={9} md={9}>
          <Typography align={"right"}>
            <MediumButton
              startIcon={<FontAwesomeIcon style={{ fontSize: 12 }} icon={faSearch} />}
              size={"small"}
              type={"submit"}
              variant="contained"
              color="primary"
            >
              {t("l.btn.search")}
            </MediumButton>
            <MediumGreyButton
              startIcon={<FontAwesomeIcon style={{ fontSize: 12 }} icon={faClose} />}
              size={"small"}
              onClick={onClear}
              style={{ marginLeft: "15px" }}
              variant="contained"
            >
              {t("l.btn.clear")}
            </MediumGreyButton>
          </Typography>
        </GridItem>
      </GridContainer>
    </>
  );
};

export default SearchSeRecognitionSection;
